import { Plus } from "lucide-react";
import { Link } from "react-router-dom";

type ModuleDrawerAddProps = {
  to: string;
  label: string;
  onNavigate?: () => void;
};

/** Thumb-friendly connect/add CTA pinned at the bottom of module slide-out drawers. */
export function ModuleDrawerAdd({ to, label, onNavigate }: ModuleDrawerAddProps) {
  return (
    <Link className="module-drawer-add" to={to} onClick={onNavigate}>
      <Plus size={18} aria-hidden />
      {label}
    </Link>
  );
}
